module.exports = __webpack_public_path__ + "img/icon_foot_search.1f087c4d.png";